// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.story_section__GYzDr {
  margin: 2rem 0;
}

/* --------media-queries---------- */

@media screen and (max-width: 568px) {
  br {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Story/story.module.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;;AAEA,oCAAoC;;AAEpC;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[".section {\n  margin: 2rem 0;\n}\n\n/* --------media-queries---------- */\n\n@media screen and (max-width: 568px) {\n  br {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section": `story_section__GYzDr`
};
export default ___CSS_LOADER_EXPORT___;
